(ns teamoesterreich.admin-mode.lebensretter.incident.incident-list
  (:require [clojure.string]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.admin-mode.actions :as a]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [teamoesterreich.view-state :as v-state]
            [teamoesterreich.admin-mode.data.lr-incident :as d-lr-incident]
            [teamoesterreich.admin-mode.lebensretter.incident.incident-info-modal :as incident-info-modal]

            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]
            [teamoesterreich.admin-mode.lebensretter.incident.incident-map :as maps-element]
            [teamoesterreich.admin-mode.lebensretter.incident.small-lr-table :as small-lr-table]
            ))


(defn sort-filter-fn [data search  sort_ reverse_ org-filter]
  (log/debug "filter-fn " sort_ reverse_  (count data) " s:" search " of:" (clj->js org-filter))
  (let [sort_ (or sort_ "incident-date")
        reverse_ (if (nil? reverse_) true reverse_)
        ;data (filter (fn [[k e]]
        ;               (and
        ;                 true
        ;                 ;(org-selector/check-org-id (:trainingEvent-orgId e) (:filter-organizationDepartment org-filter) (:filter-organization org-filter))
        ;                 (re-find
        ;                   (re-pattern (reduce (fn [c e] (str c "(?=.*" e ")")) "(?i)^" (clojure.string/split search " ")))
        ;                   (str (:trainingEvent-toeEventId e) "#" (:trainingEvent-name e)))
        ;                 ))
        ;             data)
        rows (sort-by (fn [e] (get e sort_)) data)
        rows (if reverse_ (reverse rows) rows)
        ]
    rows))


(defn update-list [!st & [search filter sort]]
  (let [!loaded? (r/cursor !st [:loaded])
        !elems (r/cursor !st [:elems])
        !search (r/cursor !st [:search])
        !org-filter (r/cursor !st [:org-filter])
        !sort (r/cursor !st [:sort])
        !reverse (r/cursor !st [:reverse])]

    (if-not @!loaded?
      (do (d-lr-incident/get-lr-incident-list
            {}
            (fn [data]
              (swap! !st assoc
                     :loaded true
                     :count (count data)
                     :elems data))
            ))
      (swap! !st assoc
             :rows (sort-filter-fn @!elems @!search @!sort @!reverse @!org-filter )
             )
      )))



(defn filter-pane [!st]
  (let [!loaded? (r/cursor !st [:loaded])]
    [mui/paper
     [mui/grid
      {:container  true
       :direction  "row"
       :alignItems "flex-start"
       :justify    "flex-start"
       :spacing    1
       :style      {:padding "5px"}
       }

      [mui/grid
       {:item true
        :xs   9
        }
       [:h3 "Lebensretter Einsätze der letzten 14 Tage"]
       ]
      [mui/grid
       {:item true
        :xs   3
        }
       [ws-event-sync-component/ws-event-reload !loaded? :lr-incident]
       ]

      ]]
    ))


(defn render [!st]
  (let [!rows (r/cursor !st [:rows])
        !search (r/cursor !st [:search])
        !filter (r/cursor !st [:filter])
        !sort (r/cursor !st [:sort])
        !waiting? (atom false)
        !popup (r/cursor !st [:popup])
        ]
    (js/console.log "Mount toe-map-list " @!search @!filter)

    (update-list !st @!search @!filter @!sort)
    [mui/grid
     {:container true
      :direction "row"
      :spacing   3
      :justify   "center"
      :style     {:marginTop "10px"}
      }
     [incident-info-modal/info-modal !popup !rows]
     [mui/grid {:item true
                :xs   12
                }

      [filter-pane !st]
      ]
     [mui/grid
      {:item   true
       :height 500
       :xs     12
       :sm     8
       }
      [maps-element/map-home !st]
      ]
     [mui/grid
      {:item   true
       :height 500
       :xs     12
       :sm     4
       }
      [mui/paper
       [:div {:style #js {:height "70px"}}
        [mui/text-field
         {:default-value (str @!search)
          :placeholder   "suche..."
          :style         {:float "left" :margin "0 5px 5px 5px" :display "inline-block"}
          :helper-text   "Freitextsuche in [Einsatznummer, TomId, Name]"
          :onChange      (h/wait-do !waiting? (fn [val]
                                                (swap! !st assoc :search val)
                                                (update-list !st @!search @!filter)))
          :multiline     false}]
        [:div {:style {:width "60px" :marginTop "20px" :display "inline-block"}}]
        ]
       (if (empty? @!rows)
         [mui/paper [:h3 "Keine Ergebnisse gefunden!"]]
         [small-lr-table/autoSizer-table !st]
         )]]]))


(defn get-it []

  (let [!st (r/cursor v-state/app-state [:lr-incident])
        ]

    [render !st]))




